export class FilterExpander {
  constructor(options) {
    this.options = options || {};
    this.rootSelector = this.options.rootSelector;
    this.filterItemSelector = this.options.filterItemSelector;
    this.root = document.querySelector(this.rootSelector);
    if (!this.root) {
      return;
    }
    this.filterItems = this.root.querySelectorAll(this.filterItemSelector) || [];
    this.toggleButton = this.root.querySelector(".show-more-btn");
    this.buttonHandler = this.buttonHandler.bind(this);
    this.visibleItemsCount = 3;
  }
  init() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", this.buttonHandler);
      this.visibleItemsCount = this.toggleButton.dataset.visibleItems || this.visibleItemsCount;
    }
  }
  /**
   * Expand the filter section
   *
   */
  expand() {
    if (this.filterItems.length <= this.visibleItemsCount) {
      return;
    }
    this.filterItems.forEach((item) => item.classList.remove("hidden"));
    this.toggleButton.setAttribute("aria-expanded", "true");
    this.toggleButton.innerText = this.toggleButton.dataset.hide;
    this.sortExpanded();
  }
  /**
   * Collapse the filter section
   *
   */
  collapse() {
    if (this.filterItems.length <= this.visibleItemsCount) {
      return;
    }
    this.filterItems.forEach((item, index) => {
      if (index >= this.visibleItemsCount) {
        item.classList.add("hidden");
      }
    });
    this.toggleButton.setAttribute("aria-expanded", "false");
    this.toggleButton.innerText = this.toggleButton.dataset.show;
    this.sortCollapsed();
  }
  /**
   * Sort the expanded section
   *
   */
  sortExpanded() {
  }
  /**
   * Sort the collapsed section
   *
   */
  sortCollapsed() {
  }
  isExpanded() {
    if (!this.toggleButton) {
      return true;
    }
    return this.toggleButton.getAttribute("aria-expanded") === "true";
  }
  /**
   * Handle the button click event
   * @private
   */
  buttonHandler() {
    if (this.isExpanded()) {
      this.collapse();
    } else {
      this.expand();
    }
  }
}
export function createFilterExpander(root) {
  return new FilterExpander(root);
}
